// src/components/RecipeViewer.js
import React, { useEffect, useState } from 'react';
import { db } from '../firebase';
import { collection, getDocs } from 'firebase/firestore';

const RecipeViewer = () => {
  const [recipes, setRecipes] = useState([]);

  useEffect(() => {
    const fetchRecipes = async () => {
      const querySnapshot = await getDocs(collection(db, 'recipes'));
      const recipeList = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setRecipes(recipeList);
    };

    fetchRecipes();
  }, []);

  return (
    <div className="h2Align">
      <h2>📖 Recipe Ingredient Viewer</h2>

      {recipes.map((recipe) => (
        <div key={recipe.id} className="recipe-card" style={{ marginBottom: '1.5rem' }}>
          <h3 style={{ marginBottom: '0.5rem' }}>{recipe.name}</h3>
          <ul style={{ paddingLeft: '1.25rem', marginBottom: 0 }}>
            {recipe.ingredients.map((ing, idx) => (
              <li key={idx}>
                {ing.code ? <strong>{ing.code}</strong> : null}
                {ing.code ? ' - ' : ''}
                {ing.product} – <strong>{ing.amount_g}g</strong>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
};

export default RecipeViewer;
